/*eslint eqeqeq: "off"*/
import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Box,
  Card,
  TableBody,
  TableCell,
  TableRow,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import { Edit as EditIcon, Trash2 as DeleteIcon } from "react-feather";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  deleteSingleDetails,
  editSingleDetails,
} from "./_product_Stock_Action";
import { fetchAllCategoryAttribute } from "../link_CategoryAttribute/_link_Cat_Att_Action";
import { getAttributeSaveValue } from "../purchase_Invoice/_purchase_Action";

import commanTable from "../../components/commanTable";
import moment from "moment";
import DeleteDialog from "src/components/DeleteDialog";

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2),
  },
}));

const headCells = [
  { id: "stockInDate", label: "Entry Date" },
  { id: "categoryName", label: "Category Name" },
  { id: "productDesignNo", label: "Design No" },
  { id: "productQty", label: "Quantity" },
  { id: "perQtyPrice", label: "Price" },
  { id: "totalPrice", label: "Total Price" },
  { id: "supplierName", label: "Supplier Name" },
  { id: "payemntDueDay", label: "Payemnt DueDay" },
  { id: "edit", label: "Edit", disableSorting: true },
  { id: "delete", label: "Delete", disableSorting: true },
];

const ProductStockList = ({ className, TableData, filterFn, ...rest }) => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dialogopen, setDialogOpen] = React.useState(false);
  const [deleteRecord, setDeleteRecord] = React.useState("");
  const [stockId, setStockId] = React.useState("");

  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting,
  } = commanTable(TableData, headCells, filterFn, 1);

  const editDetails = (id, stockId, data) => {
    dispatch(editSingleDetails(id, data));
    dispatch(fetchAllCategoryAttribute());
    dispatch(getAttributeSaveValue(0, navigate, stockId));
  };

  const openDialog = (id, stockId) => {
    setDeleteRecord(id);
    setStockId(stockId);
    setDialogOpen(!dialogopen);
  };
  const confirmDialog = () => {
    dispatch(deleteSingleDetails(deleteRecord, stockId));
  };

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <PerfectScrollbar>
        <Box minWidth={1050}>
          <TblContainer>
            <TblHead />
            {TableData.length > 0 ? (
              <TableBody>
                {/* {TableData.slice(0, limit).map((row) => ( */}
                {recordsAfterPagingAndSorting().map((row) => (
                  <TableRow hover key={row.id}>
                    <TableCell>
                      {moment(row.stockInDate).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell>{row.categoryName}</TableCell>
                    <TableCell>
                      {row.productDesignNo || "Not Available"}
                    </TableCell>
                    <TableCell>{row.productQty}</TableCell>
                    <TableCell>{row.perQtyPrice.toFixed(2)}</TableCell>
                    <TableCell>{row.totalPrice.toFixed(2)}</TableCell>
                    <TableCell>{row.supplierName}</TableCell>
                    <TableCell>{row.payemntDueDay}</TableCell>
                    <TableCell width="5%">
                      <IconButton
                        size="small"
                        onClick={() =>
                          editDetails(row.id, row.productStockStoreId, row)
                        }
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell width="5%">
                      <IconButton
                        size="small"
                        onClick={() =>
                          openDialog(row.id, row.productStockStoreId)
                        }
                      >
                        <DeleteIcon />
                        {deleteRecord == row.id ? (
                          <DeleteDialog
                            openDialog={openDialog}
                            confirmDialog={confirmDialog}
                            dialogopen={dialogopen}
                          />
                        ) : (
                          ""
                        )}
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <caption>No Record Found...</caption>
            )}
          </TblContainer>
        </Box>
      </PerfectScrollbar>
      <TblPagination />
    </Card>
  );
};

ProductStockList.propTypes = {
  className: PropTypes.string,
  //TableData: PropTypes.array.isRequired
};

export default ProductStockList;
